import "../Styles/Pages.css";
import Header from "../Components/Header";
import Map from "../Components/Map";
import Return from "../Components/Return";

export default function FindUs() {
  return (
    <div className="page_container">
      <Header />
      <h1>Find Us</h1>
      <Map />
      <Return />
    </div>
  );
}
